import { CommonModule } from '@angular/common';
import { Component, Input, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
    selector: 'icon-cheque',
    standalone: true,
    imports: [CommonModule],
    template: `
        <ng-template #template>
            <svg
                width="24"
                height="24"
                viewBox="0 0 80 56"
                xmlns="http://www.w3.org/2000/svg"
                [ngClass]="class"
                aria-hidden="true"
            >
                <!-- Folded cheque pages -->
                <polygon fill="#E8E8E8" points="2,20 14,14 14,48 2,42" />
                <polygon fill="#F3F3F3" points="6,18 14,14 14,48 6,44" />
                <polygon fill="#FFFFFF" points="10,15 14,14 14,48 10,46" />

                <!-- Cheque body -->
                <rect x="14" y="14" width="64" height="34" rx="1" fill="#F5F5F5" />

                <!-- Top field bar -->
                <rect x="16" y="16" width="22" height="3" rx="0.5" fill="#E0E0E0" />

                <!-- Date boxes -->
                <rect x="58" y="16" width="4" height="4" rx="0.5" fill="#FFFFFF" />
                <rect x="63" y="16" width="4" height="4" rx="0.5" fill="#FFFFFF" />
                <rect x="68" y="16" width="4" height="4" rx="0.5" fill="#FFFFFF" />
                <rect x="73" y="16" width="4" height="4" rx="0.5" fill="#FFFFFF" />

                <!-- Main content band -->
                <rect x="14" y="22" width="64" height="18" fill="#99D5C9" />

                <!-- Amount / payee lines -->
                <rect x="18" y="26" width="24" height="2" rx="0.5" fill="#7CB9AD" />
                <rect x="18" y="30" width="20" height="2" rx="0.5" fill="#7CB9AD" />
                <rect x="18" y="34" width="16" height="2" rx="0.5" fill="#7CB9AD" />

                <!-- Signature box -->
                <rect x="62" y="34" width="12" height="4" rx="0.5" fill="#FFFFFF" />

                <!-- MICR characters -->
                <rect x="16" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="20" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="24" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="28" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="32" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="36" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="40" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="44" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="48" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="52" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="56" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="60" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="64" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="68" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />
                <rect x="72" y="44" width="3" height="2" rx="0.3" fill="#D8D8D8" />

                <!-- Fountain pen -->
                <g transform="rotate(-38 58 26)">
                    <!-- Cap -->
                    <rect x="54" y="4" width="8" height="14" rx="1.5" fill="#4D4D4D" />
                    <rect x="54" y="4" width="8" height="2" rx="1" fill="#3D3D3D" />
                    <rect x="60" y="5" width="1.5" height="11" rx="0.5" fill="#F5C48B" />

                    <!-- Barrel -->
                    <rect x="55" y="18" width="6" height="20" rx="0.5" fill="#999999" />
                    <rect x="55" y="36" width="6" height="2" fill="#4D4D4D" />

                    <!-- Nib -->
                    <polygon fill="#F5C48B" points="55,38 61,38 58,46" />
                    <circle cx="58" cy="43" r="0.8" fill="#4D4D4D" />
                </g>
            </svg>
        </ng-template>
    `,
})
export class IconChequeComponent {
    @Input() class: any = '';
    @ViewChild('template', { static: true }) template: any;
    constructor(private viewContainerRef: ViewContainerRef) {}
    ngOnInit() {
        this.viewContainerRef.createEmbeddedView(this.template);
        this.viewContainerRef.element.nativeElement.remove();
    }
}
